import { BreadcrumbItem, renderFieldIfText } from '@acme/foundation';
import { $application, $participants } from '@entities/application';
import { useUnit } from 'effector-react';
import { Card } from 'flowbite-react';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSetApplicationBreadcrumbs } from '../../application/ui/applicationLayout';

export const ApplicationClientPage = () => {
  const navigate = useNavigate();

  const { application, participants } = useUnit({
    application: $application,
    participants: $participants,
  });

  const breadcrumbItems: BreadcrumbItem[] = useMemo(
    () => [
      {
        label: 'Главная',
        onClick: () => navigate('/dashboard'),
      },
      ...(application
        ? [
            {
              label: application.code ?? '',
              onClick: () => navigate(`/application/${application.id}`),
            },
            {
              label: 'Клиент',
            },
          ]
        : [
            {
              label: 'Заявка не найдена',
            },
          ]),
    ],
    [navigate, application]
  );

  useSetApplicationBreadcrumbs(breadcrumbItems);

  return (
    <>
      <Card>
        <div className="grid grid-cols-3 gap-6">
          {renderFieldIfText(
            'Название',
            participants?.client?.organization?.name
          )}
          {renderFieldIfText('ИНН', participants?.client?.organization?.inn)}
          {renderFieldIfText('ОГРН', participants?.client?.organization?.ogrn)}
          {renderFieldIfText(
            'Юр. адрес',
            participants?.client?.organization?.legalAddress
          )}
          {renderFieldIfText(
            'Телефон',
            participants?.client?.organization?.phoneNumber
          )}
          {renderFieldIfText(
            'Номер счёта в банке',
            participants?.client?.organization?.bankCorrespondentAccountNumber
          )}
          {renderFieldIfText(
            'Наименование банка',
            participants?.client?.organization?.bankName
          )}
          {renderFieldIfText(
            'БИК',
            participants?.client?.organization?.bankIdentificationCode
          )}
          {renderFieldIfText(
            'Корр. счёт',
            participants?.client?.organization?.bankAccountNumber
          )}
          {renderFieldIfText(
            'Роль на платформе',
            participants?.client?.organization?.role?.name
          )}
          {renderFieldIfText(
            'Ответственное лицо',
            participants?.client?.organization?.responsiblePersonName
          )}
        </div>
      </Card>

      <Card>
        <div className="grid grid-cols-3 gap-6">
          {renderFieldIfText(
            'ФИО пользователя',
            participants?.client?.contactUser?.name
          )}
          {renderFieldIfText('СНИЛС', participants?.client?.contactUser?.snils)}
          {renderFieldIfText('ИНН', participants?.client?.contactUser?.inn)}

          {renderFieldIfText(
            'Должность',
            participants?.client?.contactUser?.position
          )}
          {renderFieldIfText(
            'Эл. почта',
            participants?.client?.contactUser?.email
          )}
          {renderFieldIfText(
            'Телефон',
            participants?.client?.contactUser?.phoneNumber
          )}
        </div>
      </Card>
    </>
  );
};
